import Urls from '@constants';

export const oidcSettings = {
	authority: Urls.URL_AUTH,
	client_id: 'tramites',
	clientId: 'tramites',
	redirect_uri: Urls.URL_APP + 'oidc-callback',
	redirectUri: Urls.URL_APP + 'oidc-callback',
	response_type: 'code',
	responseType: 'code',
	grant_type: 'refresh_token',
	grantType: 'refresh_token',
	scope: 'openid profile api1 api-tramites',
	post_logout_redirect_uri: Urls.URL_APP + 'inicio',
	postLogoutRedirectUri: Urls.URL_APP + 'inicio',
	//	popupRedirectUri: Urls.URL_APP + "oidc-popup-callback",
	automaticSilentRenew: true,
	silentRedirectUri: Urls.URL_APP + 'silent-renew-oidc.html'
}; // JSON.parse(process.env.VUE_APP_OIDC_CONFIG);
